import { Box, Link } from '@mui/material';

export function Logo({ href, src, maxHeight = 40 }: { href?: string; src: string; maxHeight?: number }) {
  return src ? (
    <Link href={href || 'https://www.treedis.com/'} target="_blank">
      <Box component="img" src={src} sx={{ maxHeight, width: 'auto', display: 'block' }} />{' '}
    </Link>
  ) : (
    <></>
  );
}
